import script from "./assocOrders.vue?vue&type=script&setup=true&lang=js"
export * from "./assocOrders.vue?vue&type=script&setup=true&lang=js"

import "./assocOrders.vue?vue&type=style&index=0&id=0357a7c7&lang=scss"

const __exports__ = script;

export default __exports__